import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InspectionDeliveryRequest } from '../classes/inspectionDeliveryRequest';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class InspectionDeliveryRequestService {
    API_INSPECTION_DELIVERY_REQUEST_URL = config.serverAddress + ':' + config.serverPort + '/inspection-delivery-request/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_INSPECTION_DELIVERY_REQUEST_URL + 'all');
    }
    getByID(id: string | null) {
        return this.http.get(this.API_INSPECTION_DELIVERY_REQUEST_URL + id);
    }
    getByIDInspectionOrder(idInspectionOrder: string | null) {
        return this.http.get(this.API_INSPECTION_DELIVERY_REQUEST_URL + 'inspection-order/' + idInspectionOrder);
    }
    create(inspectionDeliveryRequest: InspectionDeliveryRequest) {
        return this.http.post(this.API_INSPECTION_DELIVERY_REQUEST_URL + 'create', inspectionDeliveryRequest);
    }
    update(inspectionDeliveryRequest: InspectionDeliveryRequest) {
        return this.http.put(this.API_INSPECTION_DELIVERY_REQUEST_URL + 'update', inspectionDeliveryRequest);
    }
    delete(id: number) {
        return this.http.delete(this.API_INSPECTION_DELIVERY_REQUEST_URL + 'delete/' + id);
    }
}